<template>
    <f-dialog
        v-model     = "value"
        :title      = "title"
        :width      = "460"
        :storeLabel = "storeLabel"
        :show-save  = "!!unit"
        @store      = "onSelected"
        @cancel     = "onCancel"
    >
        <template v-slot:content>
            <c-site-select-single
                :customer = "customer"
                @search   = "onSearch"
                @site     = "onSite"
            />

            <div v-if="unit" class="unit-selected lm-border pa-2 mr-2" v-html="text">
            </div>
        </template>
    </f-dialog>
</template>

<script>

import CSiteSelectSingle from "@/modules/msd/unit/components/controlls/CSiteSelectSingle.vue";
import FDialog           from "@/modules/core/components/utils/FDialog.vue";

export default {
    name: "DUnitSelectDialog",

    components: {
        FDialog,
        CSiteSelectSingle,
    },

    props: {
        value: {

        },

        title: {

        },

        text: {

        },

        storeLabel: {

        },

        customer: {
        }
    },

    data: () => ({
        show    : false,
        unit    : null
    }),


    watch: {
        value () {
            this.show = this.value;
        },
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onSite (unit) {
            this.unit = unit;
        },

        onSelected () {
            this.$emit("selected", this.unit);
        },

        onSearch () {
            this.unit = null;
        }
    }
}
</script>

<style scoped>

::v-deep .v-select.v-input--dense .v-chip {
    width: calc(100% - 10px);
    margin-top: 4px;
    margin-left: 0;
    margin-right: 0;
}

::v-deep .v-chip .v-chip__content {
    width: 100%;
    justify-content: space-between;
}

.unit-selected {
    position: absolute;
    top: 180px;
    font-size: 16px;
    color: black;
}

</style>